/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import IconEmpty from '../../../../../assets/Images/icons/empty';
import RopaService from '../../../../../services/Ropa.service';
import { Tooltip } from 'antd';
import { EyeFilled } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { ROUTER } from '../../../../../constants/router';

export default function ActivityProcess({
    activityId,
    getRopaDetail,
    getRoPaDetailHeader,
}) {
    const { t } = useTranslation();
    let navigate = useNavigate();
    const [activityList, setActivityList] = useState([]);
    const [totalCount, setTotalCount] = useState([]);

    useEffect(() => {
        const getActivityList = async () => {
            await RopaService.getActivityList(activityId)
                .then((res) => {
                    if (res?.data?.resultData) {
                        setActivityList(res?.data?.resultData?.activityList);
                        setTotalCount(res?.data?.resultData?.total);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        };
        getActivityList();
    }, [activityId]);

    return (
        <div className="col-span-1 bg-white h-max rounded-xl p-4 py-6 my-4">
            <div
                className="text-sm font-semibold pb-2"
                style={{ borderBottom: '3px solid #F4F6FC' }}
            >
                {t('RR.OtherRelatedActivities')}
            </div>
            {activityList.length > 0 ? (
                <div className="overflow-auto max-h-[45vh]">
                    <div className="text-xs text-gray-500 font-semibold mt-6">
                        {t('TotalAcitivity', { length: totalCount })}
                    </div>
                    {activityList.map((item, index) => (
                        <div
                            key={index}
                            style={{ background: '#F5F6FF' }}
                            className="px-4 rounded-md mt-4"
                        >
                            <div className="flex justify-between items-center">
                                <div className="font-semibold py-3">
                                    <div className="align-middle inline-block whitespace-pre">
                                        {item.activityName}
                                    </div>
                                </div>
                                <div
                                    className="font-medium py-3 cursor-pointer"
                                    style={{ color: '#1890FF' }}
                                >
                                    <div
                                        className="hover:opacity-80 rounded-md"
                                        style={{
                                            backgroundColor: '#EEE5FF',
                                        }}
                                    >
                                        <Tooltip
                                            placement="bottom"
                                            title="View"
                                            className="cursor-pointer hover:opacity-80"
                                        >
                                            <button
                                                onClick={() => {
                                                    navigate(
                                                        `${ROUTER.DS_INVENTORY.ROPA}/${item.activityId}/view`
                                                    );
                                                    getRopaDetail(
                                                        item.activityId
                                                    );
                                                    getRoPaDetailHeader(
                                                        item.activityId
                                                    );
                                                }}
                                                style={{
                                                    borderRadius: 6,
                                                    fontSize: '1rem',
                                                    padding: '6px 10px',
                                                    color: '#7B67FB',
                                                }}
                                            >
                                                <EyeFilled />
                                            </button>
                                        </Tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="h-[20vh] grid items-center justify-center">
                    <div className="-my-20">
                        <IconEmpty />
                    </div>
                </div>
            )}
        </div>
    );
}
